import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { matchTypeApi } from '../../api';
import { EMatchTypeQueryKey, useMatchTypesStore } from '../../model';

export const useGetMatchTypesByIds = (ids?: number[], disabled = false) => {
  const { addMatchTypes, map } = useMatchTypesStore(useShallow(state => ({
    addMatchTypes: state.addMatchTypes,
    map: state.map,
  })));

  const matchTypesQuery = useQuery({
    queryKey: [
      EMatchTypeQueryKey.MATCH_TYPES,
      ids,
    ],
    enabled: !disabled && ids && !!ids.length,
    queryFn: () => matchTypeApi.getMatchTypes({ ids })
  });

  useEffect(() => {
    if (matchTypesQuery.data?.items) {
      addMatchTypes(matchTypesQuery.data.items);
    }
  }, [addMatchTypes, matchTypesQuery.data]);

  const result = useMemo(() => ({
    query: matchTypesQuery,
    matchTypeMap: map
  }), [map, matchTypesQuery]);

  return result;
};
